<template>
	<div>
		<navigation msg="运营商管理/员工信息管理" />
		<router-view />
	</div>
</template>

<script>
	import navigation from '@/components/comm/navigation.vue'
	export default {
		data() {
			return {
	
			}
		},
		components: {
			navigation
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/oper/emp/home.vue